/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { Machine } from '../../../core/_models'
import { formatDateTime } from '../../../../../utils/dayJs/format'

type Props = {

    machine: Machine
}

const CreatedInCell: FC<Props> = ({ machine }) => (

    <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-danger mb-1'>
            {machine.createdAt ? formatDateTime(machine.createdAt.toString()) : 'N/A'}
        </a>
        {/* <span>{franchise.createdAt ? franchise.createdAt.toString() : 'N/A'}</span> */}
    </div>
)

export { CreatedInCell }
